
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";

class Branding extends Component {
    render() {
        const { t, settings } = this.props;

        return (
            <div className="site-branding">
                <div className="inner">
                    <a
                        className="offcanvas-toggle cats-toggle"
                        href="#shop-categories"
                        data-toggle="offcanvas"
                        title={t("Shop Categories")}
                    >
                        {" "}
                    </a>

                    <a
                        className="offcanvas-toggle menu-toggle"
                        href="#mobile-menu"
                        data-toggle="offcanvas"
                        title={t("Shop Categories")}
                    >
                        {" "}
                        
                    </a>
                    <ExtendedLink className="site-logo d-none d-sm-table-cell" to={`${settings.baseUrl}`}>
                        <img src={(settings.logoUrl ? settings.logoUrl : "img/logo/logo.png")} alt={t("VIP Shop")} />
                    </ExtendedLink>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ settings }, ownProps) {
    return { settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(Branding));
